import { useEffect, useMemo } from 'react';
import { UserAttributeKeys } from '../userAttributes/userAttributesTypes';
import { useUserAttribute } from '../userAttributes/userAttributesQueries';
import { userCompletedContentAfterQuiz } from './recommendationsUtils';
import { useIsVariation } from '../experiments';
import { useAllProgress } from '../userProgress/userProgressQueries';
import { usePostMlRecommendationsFeedback } from './recommendationsQueries';
import { useMlRecommendationsState } from './recommendationsStore';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import Raven from 'raven-js';
export const usePrioritizeInterestRecommendations = () => {
  const {
    allProgress: {
      contentProgress
    },
    allProgressLoading: isRequestingProgress
  } = useAllProgress();
  const {
    userAttribute: quizCompletionDate,
    userAttributeLoading,
    userAttributesError
  } = useUserAttribute(UserAttributeKeys.WIZARD_COMPLETION_DATE);
  const prioritizeInterestRecommendations = useMemo(() => {
    if (isRequestingProgress || userAttributeLoading) return undefined;
    return !!quizCompletionDate && !userCompletedContentAfterQuiz(quizCompletionDate, contentProgress);
  }, [contentProgress, isRequestingProgress, quizCompletionDate, userAttributeLoading]);
  const isLoading = prioritizeInterestRecommendations === undefined;
  return {
    prioritizeInterestRecommendations,
    isLoading,
    hasError: userAttributesError
  };
};
export const useIsHomepageMLRecommendationsExperimentVariation = () => useIsVariation('acad-0027', 'variation');
export const useSetLastClickedMLRecommendationItemFromUrl = ({
  id,
  type
}) => {
  const {
    postMlRecommendationsFeedback
  } = usePostMlRecommendationsFeedback();
  const {
    setLastClickedRecommendationItem
  } = useMlRecommendationsState();
  const [{
    recommendationsCorrelationId,
    recommendationsType
  }, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (recommendationsCorrelationId && recommendationsType === 'ml' && id && type) {
      postMlRecommendationsFeedback({
        correlationId: recommendationsCorrelationId,
        entityType: type,
        entityId: id
      }).catch(Raven.captureException.bind(Raven));
      setLastClickedRecommendationItem({
        item: {
          id,
          type
        },
        correlationId: recommendationsCorrelationId
      });
      setSearchParams({
        recommendationsCorrelationId: undefined,
        recommendationsType: undefined
      });
    }
  }, [recommendationsCorrelationId, recommendationsType, id, type, setLastClickedRecommendationItem, setSearchParams, postMlRecommendationsFeedback]);
};